__turbopack_context__.v({
  "body": "scrollablePanel-module-scss-module__RUm8RW__body",
  "box": "scrollablePanel-module-scss-module__RUm8RW__box",
  "columns": "scrollablePanel-module-scss-module__RUm8RW__columns",
  "dark_columns": "scrollablePanel-module-scss-module__RUm8RW__dark_columns",
  "grid": "scrollablePanel-module-scss-module__RUm8RW__grid",
  "image": "scrollablePanel-module-scss-module__RUm8RW__image",
  "image_wrapper": "scrollablePanel-module-scss-module__RUm8RW__image_wrapper",
  "inner": "scrollablePanel-module-scss-module__RUm8RW__inner",
  "introduction": "scrollablePanel-module-scss-module__RUm8RW__introduction",
  "item_title": "scrollablePanel-module-scss-module__RUm8RW__item_title",
  "main": "scrollablePanel-module-scss-module__RUm8RW__main",
  "panel": "scrollablePanel-module-scss-module__RUm8RW__panel",
  "tagline": "scrollablePanel-module-scss-module__RUm8RW__tagline",
  "type": "scrollablePanel-module-scss-module__RUm8RW__type",
});
